import { render, staticRenderFns } from "./BigField.vue?vue&type=template&id=c2e5fcdc&lang=pug"
import script from "./BigField.vue?vue&type=script&lang=js"
export * from "./BigField.vue?vue&type=script&lang=js"
import style0 from "./BigField.vue?vue&type=style&index=0&id=c2e5fcdc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports